import { useEffect, useMemo, useRef, useCallback } from "react";
import { userRoleState, projectIdState } from "atoms/atoms-admin";
import { selectedInstanceState } from "atoms/atoms-content";
import { useRecoilValue, useRecoilState } from "recoil";
import { userRoles } from "services/brm/admin-service";
import CustomTable from "components/elements/CustomTableDivStyled";
import { BrmMainTable } from "brm/tables/BrmTables";
import PropTypes from "prop-types";
import useRefreshTableList from "hooks/useRefreshTableList";
import { TYPE } from "constants/brm";
import { isCyberSecurityExpert } from "services/user";
import * as ACQueries from "brm/system-model/access/access-queries";
import { LoadingSpinner as Loading } from "components/elements";
import { createColumnCategoryName, createColumnNameNoNav } from "brm/tables/services/column/columnFactory";

const AccessPointCategoryTable = ({ setSelectedRows, refresh, setRefresh }) => {
  const userRole = useRecoilValue(userRoleState);
  const updatedName = useRef("");
  const [selectedInstance, setSelectedInstance] = useRecoilState(selectedInstanceState);

  const cyberSecurityExpertRole = userRoles.properties[userRoles.CYBERSECURITY_EXPERT].key;
  const projectId = useRecoilValue(projectIdState);

  const { data: accessPointCategories, isError } = ACQueries.useAccessPointCategories(projectId);

  const getNameCell = useCallback(() => {
    if (userRole !== cyberSecurityExpertRole) {
      return createColumnCategoryName(selectedInstance.id, setSelectedInstance, "accessPointCategory");
    }
    return createColumnNameNoNav(selectedInstance.id, false, updatedName);
  }, [cyberSecurityExpertRole, userRole, selectedInstance.id, setSelectedInstance]);

  const columns = useMemo(() => [getNameCell()], [getNameCell]);

  // Refresh the table list if project selection changes
  useRefreshTableList(projectId, setRefresh);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh, setRefresh]);

  if (isError) {
    return <div>Error while loading Access Point Category data</div>;
  }

  if (accessPointCategories) {
    return (
      <>
        <CustomTable>
          <BrmMainTable
            data={accessPointCategories}
            columns={columns}
            setSelectedRows={setSelectedRows}
            customProps={{ id: "AccessPointCategoryTable_table" }}
            elementName={TYPE.accessPointCat}
            showRowSelect={isCyberSecurityExpert(userRole)}
          />
        </CustomTable>
      </>
    );
  }
  return <Loading />;
};

AccessPointCategoryTable.propTypes = {
  setSelectedRows: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default AccessPointCategoryTable;
